/**
 * @file   src\utils\helper.ts
 * @brief  This is a general helper file.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */


import moment from "moment-timezone"
// Format phone number string to US format
export const formatPhoneNumber = (phone: string) => {
  let formatedPhoneNumber = phone;
  if (phone && phone !== '' && phone.length >= 10) {
    formatedPhoneNumber = phone.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  return formatedPhoneNumber;
};

// Set items to the local storage.
export const setLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

// Get items from the local storage.
export const getFromLocalStorage = (key: string) => {
  const data: any = localStorage.getItem(key);
  return JSON.parse(data);
};

// Function to strip non-numeric characters from phone number
export const formatPhoneNumberforApi = (phoneNumber: string) => {
  return phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
};


// Format credit card number string to '0000 0000 0000 0000' format
export const formatCreditCardNumber = (cardNumber: string) => {
  let formattedCardNumber = cardNumber;
  if (cardNumber && cardNumber !== '' && cardNumber.length >= 16) {
    formattedCardNumber = cardNumber.replace(/\D+/g, '').replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4');
  }
  return formattedCardNumber;
};
export const formatExpirationDate = (date: string) => {
  // Remove non-digit characters
  let formattedDate = date.replace(/\D+/g, ''); 
  
  // Insert '/' after the second digit if two digits are entered
  if (formattedDate.length > 2) {
    formattedDate = `${formattedDate.slice(0, 2)}/${formattedDate.slice(2)}`;
  }
  else{
    if(parseInt(formattedDate)>12)
      formattedDate =''
  }
  // Limit to 7 characters (MM/YYYY) to prevent entering more than expected
  return formattedDate.slice(0, 7);
};

export const formatDateTimeToUs = (date: String) => {
  return moment.utc(date.toString()).tz("America/New_York").format('MM/DD/Y h:mm A')
};

// Format value to start with $ and only allow $ followed by numbers
export const formatCurrencyInput = (value: string) => {
  let formattedValue = value;

  // Remove any non-numeric characters except for the $
  formattedValue = formattedValue.replace(/[^$\d]/g, '');

  // Ensure the value starts with $ and remove extra $
  if (formattedValue && !formattedValue.startsWith('$')) {
    formattedValue = `$${formattedValue}`;
  } else {
    formattedValue = formattedValue.replace(/(\$+)/, '$'); // Remove additional $ if multiple found
  }

  return formattedValue;
};

export function validateImageTypes(file: any){
  const validExtensions = ['png','jpeg','jpg','PNG','JPG','JPEG']
  const fileExtension = file.type.split('/')[1]
  return validExtensions.includes(fileExtension)
}




export  function getVisiblePageNumbers(currentPage:number,totalPages:number)  {
  const totalPageNumbersToShow = 5;
  let startPage = Math.max(1, currentPage - Math.floor(totalPageNumbersToShow / 2));
  let endPage = startPage + totalPageNumbersToShow - 1;

  if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - totalPageNumbersToShow + 1);
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
  }

  return pageNumbers;
};


export const getBadgeClass = (status: number | null) => {
  switch (status) {
      case 0:
          return 'info m-0';
      case 1:
          return 'warning m-0';
      case 2:
          return 'alert m-0';
      case 3:
          return 'active m-0';
      default:
          return '';
  }
};

export const getOrderStatus = (status: number | null) => {
  switch (status) {
      case 0:
          return 'Ordered';
      case 1:
          return 'Order Processing';
      case 2:
          return 'Shipped';
      case 3:
          return 'Delivered';
      default:
          return 'Unknown';
  }
};

export const formatDate = (createdDate: string) => {
  const date = moment(createdDate);
  const formattedDate = date.format('MM/DD/YYYY');
  return formattedDate
}

export const convertTimeStampToDate = (timeStamp: number) => {
  return moment.unix(timeStamp).format('MMMM D, YYYY')
};

export const formatDateTimeToUserTime = (date: string) => {
  return moment(date.toString()).local().format('MM/DD/Y h:mm A');
};

